'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var toastr = require('toastr');
var Modal = require('../components/Modal');
var Log = require('../services/Log');

//-----------------------------
// handler definition

var MessageHandlers = function () {
    function MessageHandlers() {
        _classCallCheck(this, MessageHandlers);

        this.register = this.register.bind(this);
        this.handleHTML = this.handleHTML.bind(this);
        this.handleToast = this.handleToast.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleMeta = this.handleMeta.bind(this);
        this.handleExecute = this.handleExecute.bind(this);
        this.handleJSON = this.handleJSON.bind(this);
        this.handleReload = this.handleReload.bind(this);
        this.withNode = this.withNode.bind(this);
    }

    _createClass(MessageHandlers, [{
        key: 'handleHTML',
        value: function handleHTML(message) {
            switch (message.action) {

                case 'open':
                    return Modal.getInstance(message.targetId).display(message.value);

                case 'close':
                    return Modal.getInstance(message.targetId).view.modal('hide');

                case 'refresh':
                    // refresh node content
                    var node_id = $(message.value).attr('id');
                    return this.withNode(node_id, function (node) {
                        node.replaceWith(message.value);
                    });

                case 'update':
                    // replace node content
                    return this.withNode(message.targetId, function (node) {
                        node.html(message.value);
                    });

                case 'append':
                    // append content in node
                    return this.withNode(message.targetId, function (node) {
                        node.append(message.value);
                    });

                case 'prepend':
                    // prepend content in node
                    return this.withNode(message.targetId, function (node) {
                        node.prepend(message.value);
                    });

                case 'removeClass':
                    // prepend content in node
                    return this.withNode(message.targetId, function (node) {
                        node.removeClass(message.value);
                    });

                case 'replace':
                    // replace node with content
                    return this.withNode(message.targetId, function (node) {
                        node.replaceWith(message.value);
                    });

                case 'remove':
                    // remove node
                    return this.withNode(message.targetId, function (node) {
                        node.remove();
                    });

                case 'fadeIn':
                    // fadeIn node
                    return this.withNode(message.targetId, function (node) {
                        node.fadeIn();
                    });

                case 'fadeOut':
                    // fadeOut node
                    return this.withNode(message.targetId, function (node) {
                        node.fadeOut();
                    });

                case 'replaceElems':
                    // replace multiple node children
                    return this.withNode(message.targetId, function (node) {
                        $.each(message.targets, function (index) {
                            var block = $(message.html).find(message.targets[index]);
                            node.find(message.targets[index]).replaceWith(block);
                        });
                    });

                default:
                    Log.log('Unknown HTML action: ' + message.action);

            }
        }
    }, {
        key: 'handleToast',
        value: function handleToast(message) {
            switch (message.method) {
                case "info":
                    toastr.info(message.value);
                    break;
                case "warning":
                    toastr.warning(message.value);
                    break;
                case "error":
                    toastr.error(message.value);
                    break;
                default:
                    toastr.success(message.value);
                    break;
            }
        }
    }, {
        key: 'handleMeta',
        value: function handleMeta(message) {
            $("title").html(message.title);
            $("meta[name='description']").attr("content", message.description);
            $("link[rel='canonical']").attr("href", message.url);
        }
    }, {
        key: 'handleExecute',
        value: function handleExecute(message) {
            eval(message.value);
        }
    }, {
        key: 'handleRedirect',
        value: function handleRedirect(message) {
            if (message.delay) {
                setTimeout(function () {
                    window.location = message.value;
                }, message.delay);
            } else {
                window.location = message.value;
            }
        }
    }, {
        key: 'handleReload',
        value: function handleReload(message) {
            toastr.success(message.value);
            setTimeout(function () {
                location.reload(true);
            }, 1000);
        }
    }, {
        key: 'handleJSON',
        value: function handleJSON(message) {
            return message.value;
        }

        //-----------------------------
        // helpers

    }, {
        key: 'withNode',
        value: function withNode(node_id, cb) {
            var node = $('#' + node_id);
            if (node.length > 0) {
                cb(node);
                // bindCard(node);
            } else Log.log('Undefined target: ' + node_id);
        }

        //-----------------------------

    }, {
        key: 'register',
        value: function register(registry) {
            registry.register('html', this.handleHTML);
            registry.register('toast', this.handleToast);
            registry.register('redirect', this.handleRedirect);
            registry.register('reload', this.handleReload);
            registry.register('meta', this.handleMeta);
            registry.register('execute', this.handleExecute);
            registry.register('json', this.handleJSON);
        }
    }]);

    return MessageHandlers;
}();

exports.default = MessageHandlers;